export default __webpack_public_path__ + "static/media/removeFavorite.aafd663b.svg";